import { C as a, h as d, i as o, S as i, r as f } from "./main.lib-685de80d.js";
(function() {
  try {
    var e = typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, r = new e.Error().stack;
    r && (e._sentryDebugIds = e._sentryDebugIds || {}, e._sentryDebugIds[r] = "99ae2bc1-c432-4483-be05-04046f5e46a5", e._sentryDebugIdIdentifier = "sentry-dbid-99ae2bc1-c432-4483-be05-04046f5e46a5");
  } catch {
  }
})();
export {
  a as CheckoutEntryPoint,
  d as PricingBreakdown,
  o as SeamlessFooter,
  i as SeamlessHeader,
  f as register
};
//# sourceMappingURL=index.js.map
